import { useEffect, useState } from 'react';

import Slider from 'react-slick';

const Testimonial = () => {

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: '5px',
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: false,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false
				}
			}
		]
	};
	
	const testimonials = [
		{
			id: 1,
			name: 'Cojocarul Mircea',
			text: 'Produse exact ca in descriere la un pret bun.',
		},
		{
			id: 2,
			name: 'Bobor Tibor',
			text: 'Excelent! Livrare foarte rapida.',
		},
		{
			id: 3,
			name: 'Viorel',
			text: 'Totul OK. Livrat rapid.',
		},
		{
			id: 4,
			name: 'Gheorghita Mihaela',
			text: 'OK, OK, OK!',
		},
		{
			id: 5,
			name: 'Claudiu Mares',
			text: 'Foarte multumit, livrare super rapida.',
		}
	];

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        const resizeTimer = setTimeout(() => {
            window.addEventListener('resize', handleResize);
        }, 200);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimer);
        };
    }, []);

  	return (
		<div className="container-fluid testimonial my-5" id="testimonial">
			<div className="container">
				<div className="row gx-5">

					<div className="text-center" data-aos="fade-up" data-aos-offset="200" data-aos-delay="100">
						<h6 className="heading text-danger text-uppercase">Ce spun clientii?</h6>
						<h1 className="heading mb-5">Recenzii</h1>
					</div>

					<div className="carousel position-relative mt-3" data-aos="fade-down" data-aos-offset="200" data-aos-delay="300">
						<Slider {...settings} key={windowWidth}>
							{testimonials.map((testimonial, index) => (
								<a key={testimonial.id} href="https://www.emag.ro/misulxoa/180994/v?ref=see_vendor_page" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
									<div className="item text-center">
										<img
											className="bg-light rounded-circle p-2 mx-auto mb-1"
											src="./images/emag.webp"
											alt={testimonial.name}
											style={{ width: '80px', height: '80px' }}
										/>
										<h5 className="mb-3">{testimonial.name}</h5>
										<div className="box text-center">
											<p className="mb-1">{testimonial.text}</p>
										</div>
									</div>
								</a>
							))}
						</Slider>
					</div>
				</div>
			</div>
		</div>
  	);
};

export default Testimonial;